import React from 'react'
import Icon from '../icon'

export default ({ imgList, type, step, index, setIndex,
  // synchronism,
  // setSynchronism,
  // setImgList,
}) => {
  const onClick = (e) => {
    e.stopPropagation()
    setIndex && setIndex(index + step)
    // if (synchronism) {
    //   const { tagNameList, title, desc } = imgList[index]
    //   setImgList(imgList.map(m => ({ ...m, tagNameList, title, desc })))
    //   setSynchronism(false)
    // }
  }
  return <div
    className={`mn-upload-ins-${type}-arrow-container`}
    onClick={e => onClick(e)}
    style={{ background: imgList[index + step] ? '' : 'rgba(0, 0, 0, 0.11)', cursor: setIndex ? 'pointer' : 'auto' }}
  >
    <Icon className="mn-upload-ins-arrow" type={type === 'right' ? 'm-Vxing_you' : 'm-Vxing_zuo'} />
  </div>
}
